module.exports = __webpack_public_path__ + "static/media/SideBySide - Zipylne.d50b57a1.svg";